<template>
    <header class="view-header">
        <button v-if="backButton" @click="emit(EmitEvents.BACK)" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                />
            </svg>
        </button>

        <span class="title">
            <slot />
        </span>

        <button v-if="closeButton && !$slots.custom" @click="emit(EmitEvents.CLOSED)" class="close-cross">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                />
            </svg>
        </button>

        <button v-if="$slots.custom" class="custom">
            <slot name="custom" />
        </button>
    </header>
</template>

<script lang="ts" setup>
import { EmitEvents } from '@btcdirect/shared/src/components/types';

const emit = defineEmits([EmitEvents.BACK, EmitEvents.CLOSED]);

const props = defineProps({
    backButton: {
        type: Boolean,
        required: false,
        default: false
    },
    closeButton: {
        type: Boolean,
        required: false,
        default: false
    }
});

/* Used in the below CSS for mobile screens below 326px width */
const mobileTemplateColumns = props.closeButton ? '0 1fr 3.375rem' : '3.375rem 1fr 0';
const mobileTitlePaddingLeft = props.closeButton ? '1em' : '0';
</script>

<style lang="scss" scoped>
@use '@@scss/flex';
@use '@@scss/fonts';
@use '@@scss/variables';

.view-header {
    @include fonts.font(1.25em);
    background-color: var(--background-color);
    align-items: center;
    display: grid;
    flex-shrink: 0;
    grid-template-areas: 'back-arrow title close-cross';
    grid-template-columns: 3.375rem 1fr 3.375rem;
    height: variables.$header-height;

    .title {
        grid-area: title;
        justify-self: center;
        font-size: 1.125rem;
    }

    .back-arrow,
    .close-cross,
    .custom {
        @include flex.flex;
        @include flex.align(center, center);
        background-color: transparent;
        border: none;
        color: var(--text-color);
        place-self: stretch;

        svg {
            height: 1.25rem;
        }

        &:hover {
            cursor: pointer;
        }
    }

    .back-arrow {
        grid-area: back-arrow;
    }

    .close-cross,
    .custom {
        grid-area: close-cross;
    }

    @media only screen and (max-width: 325px) {
        grid-template-columns: v-bind('mobileTemplateColumns');

        .title {
            justify-self: left;
            padding-left: v-bind('mobileTitlePaddingLeft');
        }
    }
}
</style>
